<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <input
        class="form-control"
        id="form-element-{{ formField.id }}"
        maxlength="1000"
        appEmailValidator
        name="email"
        sbTrim
        autocomplete="email"
        appFocus
        [appAutoFocus]="formField.isNeedToFocus"
        [placeholder]="formField.placeholder"
        [required]="formField.isRequired"
        [(ngModel)]="formField.value"
        #field="ngModel" />

    @if (formService.isSubmitted && formField.isRequired && !formField.value) {
        <div class="text-danger" translate>Please fill this field</div>
    }

    @if (formService.isSubmitted && formField.value && field.errors && field.errors.validateEmail.invalid) {
        <div class="text-danger" translate>Please enter a valid email address</div>
    }
</div>
